const INDONESIAN_STATIC_TEXT: Record<string, string> = {
  Close: 'Tutup',
  Previous: 'Sebelumnya',
  Next: 'Berikutnya',
  ESC: 'ESC',
  'Fullscreen media viewer. Press Escape to close. Use left and right arrows to navigate.':
    'Penampil media layar penuh. Tekan Escape untuk menutup. Gunakan panah kiri dan kanan untuk berpindah.',
  'Loading full image': 'Memuat gambar penuh',
  'Loading...': 'Memuat...',
  'Loading 3D viewer...': 'Memuat penampil 3D...',
  'No source provided': 'Tidak ada sumber yang diberikan',
  'Failed to load 3D viewer library': 'Gagal memuat pustaka penampil 3D',
  'Failed to load 3D model': 'Gagal memuat model 3D',
  'Failed to load video': 'Gagal memuat video',
  'Video loading aborted': 'Pemuatan video dibatalkan',
  'Network error loading video': 'Kesalahan jaringan saat memuat video',
  'Video decoding error': 'Kesalahan dekode video',
  'Video format not supported': 'Format video tidak didukung',
  'No video source available': 'Tidak ada sumber video yang tersedia',
  'Loading video...': 'Memuat video...',
  'Video Asset': 'Aset Video',
  'URL not accessible': 'URL tidak dapat diakses',
  'URL accessible': 'URL dapat diakses',
  Yes: 'Ya',
  No: 'Tidak',
  Source: 'Sumber',
  Sidebar: 'Bilah samping',
  'Displays the mobile sidebar.': 'Menampilkan bilah samping seluler.',
  'Toggle Sidebar': 'Alihkan bilah samping',
  'More pages': 'Halaman lainnya',
  'Go to previous page': 'Ke halaman sebelumnya',
  'Go to next page': 'Ke halaman berikutnya',
  'Page not found': 'Halaman tidak ditemukan',
  "The page you are looking for doesn't exist or has been moved.":
    'Halaman yang Anda cari tidak ada atau telah dipindahkan.',
  'Access denied': 'Akses ditolak',
  "You don't have permission to view this page. Ask a workspace admin for access if you think this is a mistake.":
    'Anda tidak memiliki izin untuk melihat halaman ini. Minta akses kepada admin ruang kerja jika menurut Anda ini adalah kesalahan.',
  'Go back': 'Kembali',
  'Go home': 'Ke beranda',
  'Go to dashboard': 'Ke dasbor',
  Error: 'Kesalahan',
  'Something went wrong': 'Terjadi kesalahan',
  'An unexpected error occurred.': 'Terjadi kesalahan yang tidak terduga.',
  'Try again': 'Coba lagi',
  'Please try again. If this keeps happening, contact support.':
    'Silakan coba lagi. Jika masalah berlanjut, hubungi dukungan.',
  Reference: 'Referensi',
  Suggestions: 'Saran',
};

export function createIndonesianStaticCopy<T>(value: T): T {
  if (typeof value === 'string')
    return (INDONESIAN_STATIC_TEXT[value] ?? value) as T;
  if (Array.isArray(value)) return value.map(createIndonesianStaticCopy) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [
        key,
        createIndonesianStaticCopy(nested),
      ])
    ) as T;
  }
  return value;
}
